import { AjaxResponse } from "../ajax/types";
import { Entity } from "../../state/entity";
import { EndpointResponse } from "../endpoint";
import { StatusCode } from "../ajax/statusCode";

class JSONResponse implements EndpointResponse {

    constructor(ajaxResponse: AjaxResponse) {
        this._status = ajaxResponse.status;
        this._data = this.parse(ajaxResponse.response);
    }

    public get data(): Entity {
        return this._data;
    }

    public set data(value: Entity) {
        this._data = value;
    }

    public get succeeded(): boolean {
        return StatusCode.IsSuccess(this._status);
    }

    public get status(): StatusCode {
        return this._status;
    }

    private parse(json: string): Entity {
        try {
            var response = JSON.parse(json);
        }
        catch (e) {
            response = null;
        }
        return response === null ?
            {} :
            response;
    }

    // self
    private _status: StatusCode;
    private _data: Entity;
}

class EntityJSONResponse extends JSONResponse {
    constructor(ajaxResponse: AjaxResponse) {
        super(ajaxResponse);
        if (this.succeeded) {
            if (this.data != null) {
                this.data = this.convert(this.data);
            }
        }
    }

    protected convert(transportObject: Entity): Entity {
        return transportObject;
    }
}
export {
    EntityJSONResponse,
    JSONResponse
}
